// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.pricingContainer_dCXgD {
  display: flex;
  flex-direction: column;
  position: relative;
  align-items: center;
  justify-content: flex-start;
  width: 100%;
  background: linear-gradient(180deg, #ffffff 21%, #f5f5f5 100%);
  overflow-x: hidden;
  font-family: "Inter", sans-serif;
  padding-top: 50px;
}

.plansHeader_cQZoX {
  display: flex;
  flex-direction: column;
  gap: 20px;
  width: 80%;
  text-align: center;
  margin-top: 20px;
}

@media (max-width: 450px) {
  .plansHeader_cQZoX {
    width: 80%;
    margin: 0 auto;
  }
}

.containerP_zLpTy {
  display: flex;
  flex-direction: column;
  justify-content: start;
  width: 100%;
  align-items: center;
}
.plansTitle_iVwp0 {
  font-weight: 400;
  font-size: clamp(28px, 5vw, 40px);
  color: #18181b;
  margin: 0;
  text-align: center;
}



.cardsPlansContainer_XIJHq {
  display: flex;
  flex-direction: column;
  min-height: fit-content;

  gap: 40px;
  width: 100%;
  .cardsContainer_xG9wR {
    width: 100%;
    display: flex;
    gap: 40px;
    min-height: fit-content;
    flex-wrap: wrap;
    .card_QRIIK {
      flex: 1 1;
      box-sizing: border-box;
      background: linear-gradient(to bottom, #f5f5f5, #ffffff);
      text-align: start;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      gap: 20px;
      border-radius: 16px;
      padding: 20px;
      -webkit-border-radius: 16px;
      -moz-border-radius: 16px;
      -ms-border-radius: 16px;
      -o-border-radius: 16px;
      height: fit-content;
      min-width: 300px;
      button {
        background-color: transparent;
        outline: none;
        border: none;
        width: fit-content;
        display: flex;
        align-items: center;
        gap: 10px;
        cursor: pointer;
        margin: 10px 0px;
        padding: 12px;
        border-radius: 99px;
        -webkit-border-radius: 99px;
        -moz-border-radius: 99px;
        -ms-border-radius: 99px;
        -o-border-radius: 99px;
      }
      .customButton_yT9va {
        background-color: #2c2c2cba;
        color: var(--white-color);
      }

      .featuresContainer_SSWG5 {
        display: flex;
        flex-direction: column;
        gap: 10px;
        p {
          color: #18181b;
          display: flex;
          align-items: center;
          gap: 5px;
          svg {
            min-width: 24px;
          }
        }
      }

      h3 {
        font-weight: 500;
        font-size: 25px;
      }
      h3,
      p {
        margin: 0;
      }
    }
  }
}

.slider_arTeq {
  appearance: none;
  width: 100%;
  height: 10px;
  border-radius: 5px;
  outline: none;
  cursor: pointer;
  position: relative; 
  z-index: 2; 
  padding: 0px;
}

.slider_arTeq::-webkit-slider-thumb {
  appearance: none;
  width: 20px;
  height: 20px;
  background: var(--_16c098-color);
  border-radius: 50%;
  cursor: pointer;
  box-shadow: 0 0 4px var(--_00000033-shadow);
}

.slider_arTeq::-moz-range-thumb {
  width: 20px;
  height: 20px;
  background: var(--_16c098-color);
  border-radius: 50%;
  cursor: pointer;
}



.lightText_MCY6X{
  color: #676767;
  font-size: clamp(15px, 5vw, 20px);
  font-weight: 400;
  margin-top: 80px;
  max-width: 800px;
  text-align: center;
}
.lightText_MCY6X {
  line-height: 40px;
}


.cardContainer_m1QgT {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 30px;


  .row2_H4Kzs {
    gap: 70px;
  }
}


@media (max-width: 768px) {
  .cardContainer_m1QgT {
    max-width: 100%;
    overflow: hidden;
  }
}

@media (min-width: 769px) {
  .cardContainer_m1QgT {
    max-width: 1250px;
    margin: 2.5rem auto;
  }


}



.reviewsTitle_BAv_U {
  font-size: clamp(32px, 5vw, 50px);
  font-weight: 400;
  color: #18181b;
  text-align: center;
}

.reviewsDescriptionLast_Ad8Ya {
  font-size: clamp(16px, 3vw, 22px);
  font-weight: 400;
  max-width: 720px;
  margin-top: 5px;
  color: #676767;
  text-align: center;
}

.startButton_nBMFK {
  margin-top: 20px;
  margin-bottom: 100px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 999px;
  color: var(--white-background);
  font-size: 18px;
  font-weight: 400;
  background: var(--_10a37f-background);
  width: 100%;
  max-width: 244px;
  height: 57px;
  min-height: 57px;
  text-decoration: none;
  gap: 15px;
  border-radius: 999px;
  -webkit-border-radius: 999px;
  -moz-border-radius: 999px;
  -ms-border-radius: 999px;
  -o-border-radius: 999px;
}


.tableBenefitsContainer_mxM0w {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 20px;
  width: 100%;
  margin: 40px 0;
}
.benefitsTable_SjtT0 {
  display: flex;
  justify-content: center;
  width: 100%;
}

.trustContainer_C7pGr {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 120px;
  margin: 50px 0px;
}

.googleCard_wJgi_ {
  display: flex;
  flex-direction: column-reverse;
  align-items: center;
  justify-content: center;
  gap: 30px;
  background: var(--white-background);
  box-shadow: 5px 0px 40px var(--_0000001a-shadow);
  border-radius: 20px;
  width: 100%;
  flex: 1 1;
  height: 242px;
  -webkit-border-radius: 20px;
  -moz-border-radius: 20px;
  -ms-border-radius: 20px;
  -o-border-radius: 20px;
}

.starsContainer_OIS8Q {
  display: flex;
  justify-content: center;
  gap: 4px;
  margin-bottom: 10px;
}

.topTrustpilotStar_NGfIj {
  width: clamp(30px, 5vw, 38px);
  height: clamp(30px, 5vw, 38px);
}

.googleLogo_uf_yf {
  width: clamp(100px, 15vw, 125px);
  height: clamp(100px, 15vw, 125px);
}

.trustpilotCard_cXJye {
  background: var(--white-background);
  border-radius: 20px;
  box-shadow: 4px 4px 40px var(--_0000001a-shadow);
  width: 475px;
  flex: 1 1;
  border-radius: 20px;
  -webkit-border-radius: 20px;
  -moz-border-radius: 20px;
  -ms-border-radius: 20px;
  -o-border-radius: 20px;
  overflow: hidden;
}

.topContainer_F0E36 {
  display: flex;
  background-color: #00b67a;
  height: 58px;
  align-items: center;
  justify-content: center;
  gap: 8px;
  color: var(--white-background);
  padding: 8px;
  font-weight: bold;
  font-size: clamp(24px, 4vw, 32px);
}

.bottomContainer_l1dN2 {
  display: flex;
  text-align: center;
  gap: 8px;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding-top: 15px;
  padding: 30px 20px;
}

.trustpilotBottomStars_pBS4b {
  display: flex;
  justify-content: center;
  gap: 20px;
  margin: 10px 0;
  margin-bottom: 20px;
}

.trustStarContainer_v6HvN {
  width: clamp(30px, 5vw, 40px);
  height: clamp(30px, 5vw, 40px);
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #219653;
}

.bottomText_WoH3Z {
  font-size: clamp(12px, 2vw, 14px);
  color: #555454;
}

.bottomText_WoH3Z span {
  font-weight: bold;
  text-decoration: underline;
  color: #18181b;
}

@media (max-width: 768px) {
  .pricingContainer_dCXgD {
    padding-top: 80px;
  }

  .trustContainer_C7pGr {
    flex-direction: column;
  }
  .googleCard_wJgi_ {
    max-width: 100%;
  }
}

@media (max-width: 480px) {
  .pricingContainer_dCXgD {
    padding-top: 60px;
  }


  .cardContainer_m1QgT {
    gap: 1.5rem;
  }
}

.parent_tCf9z {
  display: grid;
  grid-auto-flow: dense;
  grid-template-columns: repeat(9, auto);
  grid-template-rows: auto;
  gap: 10px;
  width: auto;
  margin-top: 40px;
  row-gap: 20px;
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
}
@media (width<=600px) {
  .pricingCardContainer_URDsz {
    width: 80%;
  }
}
/* .div1 {
  grid-area: 1 / 1 / 2 / 3;
}
.div2 {
  grid-area: 1 / 3 / 2 / 5;
}
.div3 {
  grid-area: 1 / 6 / 2 / 8;
}
.div4 {
  grid-area: 1 / 8 / 2 / 10;
}
.div5 {
  grid-area: 2 / 1 / 3 / 3;
  margin-left: -40px;
  margin-right: 40px;
}
.div6 {
  grid-area: 2 / 3 / 3 / 5;
  margin-left: -27px;
}
.div7 {
  grid-area: 2 / 6 / 3 / 8;
  margin-left: 27px;
  margin-right: -40px;
}
.div8 {
  grid-area: 2 / 8 / 3 / 10;
  margin-left: 40px;
  margin-right: -40px;
}
.div9 {
  grid-area: 3 / 2 / 4 / 4;
}
.div10 {
  grid-area: 3 / 4 / 4 / 7;
}
.div11 {
  grid-area: 3 / 7 / 4 / 9;
}

@media (max-width: 935px) {
  .parent {
    grid-template-columns: repeat(2, 1fr);
  }
  .div1,
  .div2,
  .div3,
  .div4,
  .div5,
  .div6,
  .div7,
  .div8,
  .div9,
  .div10,
  .div11 {
    margin: 0;
  }
  .div1 {
    grid-area: 1 / 1 / 2 / 2;
  }
  .div2 {
    grid-area: 1 / 2 / 2 / 3;
  }
  .div3 {
    grid-area: 2 / 1 / 3 / 2;
  }
  .div4 {
    grid-area: 2 / 2 / 3 / 3;
  }
  .div5 {
    grid-area: 3 / 1 / 4 / 2;
  }
  .div6 {
    grid-area: 3 / 2 / 4 / 3;
  }
  .div7 {
    grid-area: 4 / 1 / 5 / 2;
  }
  .div8 {
    grid-area: 4 / 2 / 5 / 3;
  }
  .div9 {
    grid-area: 5 / 1 / 6 / 2;
  }
  .div10 {
    grid-area: 5 / 2 / 6 / 3;
  }
  .div11 {
    grid-area: 6 / 1 / 7 / 2;
  }
}

@media (max-width: 480px) {
  .parent {
    grid-template-columns: 1fr;
  }
  .div1 {
    grid-area: 1 / 1 / 2 / 2;
  }
  .div2 {
    grid-area: 2 / 1 / 3 / 2;
  }
  .div3 {
    grid-area: 3 / 1 / 4 / 2;
  }
  .div4 {
    grid-area: 4 / 1 / 5 / 2;
  }
  .div5 {
    grid-area: 5 / 1 / 6 / 2;
  }
  .div6 {
    grid-area: 6 / 1 / 7 / 2;
  }
  .div7 {
    grid-area: 7 / 1 / 8 / 2;
  }
  .div8 {
    grid-area: 8 / 1 / 9 / 2;
  }
  .div9 {
    grid-area: 9 / 1 / 10 / 2;
  }
  .div10 {
    grid-area: 10 / 1 / 11 / 2;
  }
  .div11 {
    grid-area: 11 / 1 / 12 / 2;
  }
} */
`, "",{"version":3,"sources":["webpack://./src/views/Dashboard/screens/Pricing/Pricing.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,kBAAkB;EAClB,mBAAmB;EACnB,2BAA2B;EAC3B,WAAW;EACX,8DAA8D;EAC9D,kBAAkB;EAClB,gCAAgC;EAChC,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,UAAU;EACV,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE;IACE,UAAU;IACV,cAAc;EAChB;AACF;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,sBAAsB;EACtB,WAAW;EACX,mBAAmB;AACrB;AACA;EACE,gBAAgB;EAChB,iCAAiC;EACjC,cAAc;EACd,SAAS;EACT,kBAAkB;AACpB;;;;AAIA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;;EAEvB,SAAS;EACT,WAAW;EACX;IACE,WAAW;IACX,aAAa;IACb,SAAS;IACT,uBAAuB;IACvB,eAAe;IACf;MACE,SAAO;MACP,sBAAsB;MACtB,wDAAwD;MACxD,iBAAiB;MACjB,aAAa;MACb,sBAAsB;MACtB,8BAA8B;MAC9B,SAAS;MACT,mBAAmB;MACnB,aAAa;MACb,2BAA2B;MAC3B,wBAAwB;MACxB,uBAAuB;MACvB,sBAAsB;MACtB,mBAAmB;MACnB,gBAAgB;MAChB;QACE,6BAA6B;QAC7B,aAAa;QACb,YAAY;QACZ,kBAAkB;QAClB,aAAa;QACb,mBAAmB;QACnB,SAAS;QACT,eAAe;QACf,gBAAgB;QAChB,aAAa;QACb,mBAAmB;QACnB,2BAA2B;QAC3B,wBAAwB;QACxB,uBAAuB;QACvB,sBAAsB;MACxB;MACA;QACE,2BAA2B;QAC3B,yBAAyB;MAC3B;;MAEA;QACE,aAAa;QACb,sBAAsB;QACtB,SAAS;QACT;UACE,cAAc;UACd,aAAa;UACb,mBAAmB;UACnB,QAAQ;UACR;YACE,eAAe;UACjB;QACF;MACF;;MAEA;QACE,gBAAgB;QAChB,eAAe;MACjB;MACA;;QAEE,SAAS;MACX;IACF;EACF;AACF;;AAEA;EAEE,gBAAgB;EAChB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,eAAe;EACf,kBAAkB;EAClB,UAAU;EACV,YAAY;AACd;;AAEA;EAEE,gBAAgB;EAChB,WAAW;EACX,YAAY;EACZ,gCAAgC;EAChC,kBAAkB;EAClB,eAAe;EACf,2CAA2C;AAC7C;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,gCAAgC;EAChC,kBAAkB;EAClB,eAAe;AACjB;;;;AAIA;EACE,cAAc;EACd,iCAAiC;EACjC,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;AACpB;AACA;EACE,iBAAiB;AACnB;;;AAGA;EACE,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;;;EAGT;IACE,SAAS;EACX;AACF;;;AAGA;EACE;IACE,eAAe;IACf,gBAAgB;EAClB;AACF;;AAEA;EACE;IACE,iBAAiB;IACjB,mBAAmB;EACrB;;;AAGF;;;;AAIA;EACE,iCAAiC;EACjC,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,iCAAiC;EACjC,gBAAgB;EAChB,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,oBAAoB;EACpB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,oBAAoB;EACpB,8BAA8B;EAC9B,eAAe;EACf,gBAAgB;EAChB,qCAAqC;EACrC,WAAW;EACX,gBAAgB;EAChB,YAAY;EACZ,gBAAgB;EAChB,qBAAqB;EACrB,SAAS;EACT,oBAAoB;EACpB,4BAA4B;EAC5B,yBAAyB;EACzB,wBAAwB;EACxB,uBAAuB;AACzB;;;AAGA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,SAAS;EACT,WAAW;EACX,cAAc;AAChB;AACA;EACE,aAAa;EACb,uBAAuB;EACvB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,UAAU;EACV,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,mCAAmC;EACnC,gDAAgD;EAChD,mBAAmB;EACnB,WAAW;EACX,SAAO;EACP,aAAa;EACb,2BAA2B;EAC3B,wBAAwB;EACxB,uBAAuB;EACvB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,QAAQ;EACR,mBAAmB;AACrB;;AAEA;EACE,6BAA6B;EAC7B,8BAA8B;AAChC;;AAEA;EACE,gCAAgC;EAChC,iCAAiC;AACnC;;AAEA;EACE,mCAAmC;EACnC,mBAAmB;EACnB,gDAAgD;EAChD,YAAY;EACZ,SAAO;EACP,mBAAmB;EACnB,2BAA2B;EAC3B,wBAAwB;EACxB,uBAAuB;EACvB,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,YAAY;EACZ,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,8BAA8B;EAC9B,YAAY;EACZ,iBAAiB;EACjB,iCAAiC;AACnC;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,QAAQ;EACR,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,6BAA6B;EAC7B,8BAA8B;EAC9B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,yBAAyB;AAC3B;;AAEA;EACE,iCAAiC;EACjC,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,0BAA0B;EAC1B,cAAc;AAChB;;AAEA;EACE;IACE,iBAAiB;EACnB;;EAEA;IACE,sBAAsB;EACxB;EACA;IACE,eAAe;EACjB;AACF;;AAEA;EACE;IACE,iBAAiB;EACnB;;;EAGA;IACE,WAAW;EACb;AACF;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,sCAAsC;EACtC,wBAAwB;EACxB,SAAS;EACT,WAAW;EACX,gBAAgB;EAChB,aAAa;EACb,aAAa;EACb,eAAe;EACf,uBAAuB;AACzB;AACA;EACE;IACE,UAAU;EACZ;AACF;AACA;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;GAkIG","sourcesContent":[".pricingContainer {\n  display: flex;\n  flex-direction: column;\n  position: relative;\n  align-items: center;\n  justify-content: flex-start;\n  width: 100%;\n  background: linear-gradient(180deg, #ffffff 21%, #f5f5f5 100%);\n  overflow-x: hidden;\n  font-family: \"Inter\", sans-serif;\n  padding-top: 50px;\n}\n\n.plansHeader {\n  display: flex;\n  flex-direction: column;\n  gap: 20px;\n  width: 80%;\n  text-align: center;\n  margin-top: 20px;\n}\n\n@media (max-width: 450px) {\n  .plansHeader {\n    width: 80%;\n    margin: 0 auto;\n  }\n}\n\n.containerP {\n  display: flex;\n  flex-direction: column;\n  justify-content: start;\n  width: 100%;\n  align-items: center;\n}\n.plansTitle {\n  font-weight: 400;\n  font-size: clamp(28px, 5vw, 40px);\n  color: #18181b;\n  margin: 0;\n  text-align: center;\n}\n\n\n\n.cardsPlansContainer {\n  display: flex;\n  flex-direction: column;\n  min-height: fit-content;\n\n  gap: 40px;\n  width: 100%;\n  .cardsContainer {\n    width: 100%;\n    display: flex;\n    gap: 40px;\n    min-height: fit-content;\n    flex-wrap: wrap;\n    .card {\n      flex: 1;\n      box-sizing: border-box;\n      background: linear-gradient(to bottom, #f5f5f5, #ffffff);\n      text-align: start;\n      display: flex;\n      flex-direction: column;\n      justify-content: space-between;\n      gap: 20px;\n      border-radius: 16px;\n      padding: 20px;\n      -webkit-border-radius: 16px;\n      -moz-border-radius: 16px;\n      -ms-border-radius: 16px;\n      -o-border-radius: 16px;\n      height: fit-content;\n      min-width: 300px;\n      button {\n        background-color: transparent;\n        outline: none;\n        border: none;\n        width: fit-content;\n        display: flex;\n        align-items: center;\n        gap: 10px;\n        cursor: pointer;\n        margin: 10px 0px;\n        padding: 12px;\n        border-radius: 99px;\n        -webkit-border-radius: 99px;\n        -moz-border-radius: 99px;\n        -ms-border-radius: 99px;\n        -o-border-radius: 99px;\n      }\n      .customButton {\n        background-color: #2c2c2cba;\n        color: var(--white-color);\n      }\n\n      .featuresContainer {\n        display: flex;\n        flex-direction: column;\n        gap: 10px;\n        p {\n          color: #18181b;\n          display: flex;\n          align-items: center;\n          gap: 5px;\n          svg {\n            min-width: 24px;\n          }\n        }\n      }\n\n      h3 {\n        font-weight: 500;\n        font-size: 25px;\n      }\n      h3,\n      p {\n        margin: 0;\n      }\n    }\n  }\n}\n\n.slider {\n  -webkit-appearance: none;\n  appearance: none;\n  width: 100%;\n  height: 10px;\n  border-radius: 5px;\n  outline: none;\n  cursor: pointer;\n  position: relative; \n  z-index: 2; \n  padding: 0px;\n}\n\n.slider::-webkit-slider-thumb {\n  -webkit-appearance: none;\n  appearance: none;\n  width: 20px;\n  height: 20px;\n  background: var(--_16c098-color);\n  border-radius: 50%;\n  cursor: pointer;\n  box-shadow: 0 0 4px var(--_00000033-shadow);\n}\n\n.slider::-moz-range-thumb {\n  width: 20px;\n  height: 20px;\n  background: var(--_16c098-color);\n  border-radius: 50%;\n  cursor: pointer;\n}\n\n\n\n.lightText{\n  color: #676767;\n  font-size: clamp(15px, 5vw, 20px);\n  font-weight: 400;\n  margin-top: 80px;\n  max-width: 800px;\n  text-align: center;\n}\n.lightText {\n  line-height: 40px;\n}\n\n\n.cardContainer {\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  gap: 30px;\n\n\n  .row2 {\n    gap: 70px;\n  }\n}\n\n\n@media (max-width: 768px) {\n  .cardContainer {\n    max-width: 100%;\n    overflow: hidden;\n  }\n}\n\n@media (min-width: 769px) {\n  .cardContainer {\n    max-width: 1250px;\n    margin: 2.5rem auto;\n  }\n\n\n}\n\n\n\n.reviewsTitle {\n  font-size: clamp(32px, 5vw, 50px);\n  font-weight: 400;\n  color: #18181b;\n  text-align: center;\n}\n\n.reviewsDescriptionLast {\n  font-size: clamp(16px, 3vw, 22px);\n  font-weight: 400;\n  max-width: 720px;\n  margin-top: 5px;\n  color: #676767;\n  text-align: center;\n}\n\n.startButton {\n  margin-top: 20px;\n  margin-bottom: 100px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border-radius: 999px;\n  color: var(--white-background);\n  font-size: 18px;\n  font-weight: 400;\n  background: var(--_10a37f-background);\n  width: 100%;\n  max-width: 244px;\n  height: 57px;\n  min-height: 57px;\n  text-decoration: none;\n  gap: 15px;\n  border-radius: 999px;\n  -webkit-border-radius: 999px;\n  -moz-border-radius: 999px;\n  -ms-border-radius: 999px;\n  -o-border-radius: 999px;\n}\n\n\n.tableBenefitsContainer {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 20px;\n  width: 100%;\n  margin: 40px 0;\n}\n.benefitsTable {\n  display: flex;\n  justify-content: center;\n  width: 100%;\n}\n\n.trustContainer {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  gap: 120px;\n  margin: 50px 0px;\n}\n\n.googleCard {\n  display: flex;\n  flex-direction: column-reverse;\n  align-items: center;\n  justify-content: center;\n  gap: 30px;\n  background: var(--white-background);\n  box-shadow: 5px 0px 40px var(--_0000001a-shadow);\n  border-radius: 20px;\n  width: 100%;\n  flex: 1;\n  height: 242px;\n  -webkit-border-radius: 20px;\n  -moz-border-radius: 20px;\n  -ms-border-radius: 20px;\n  -o-border-radius: 20px;\n}\n\n.starsContainer {\n  display: flex;\n  justify-content: center;\n  gap: 4px;\n  margin-bottom: 10px;\n}\n\n.topTrustpilotStar {\n  width: clamp(30px, 5vw, 38px);\n  height: clamp(30px, 5vw, 38px);\n}\n\n.googleLogo {\n  width: clamp(100px, 15vw, 125px);\n  height: clamp(100px, 15vw, 125px);\n}\n\n.trustpilotCard {\n  background: var(--white-background);\n  border-radius: 20px;\n  box-shadow: 4px 4px 40px var(--_0000001a-shadow);\n  width: 475px;\n  flex: 1;\n  border-radius: 20px;\n  -webkit-border-radius: 20px;\n  -moz-border-radius: 20px;\n  -ms-border-radius: 20px;\n  -o-border-radius: 20px;\n  overflow: hidden;\n}\n\n.topContainer {\n  display: flex;\n  background-color: #00b67a;\n  height: 58px;\n  align-items: center;\n  justify-content: center;\n  gap: 8px;\n  color: var(--white-background);\n  padding: 8px;\n  font-weight: bold;\n  font-size: clamp(24px, 4vw, 32px);\n}\n\n.bottomContainer {\n  display: flex;\n  text-align: center;\n  gap: 8px;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  padding-top: 15px;\n  padding: 30px 20px;\n}\n\n.trustpilotBottomStars {\n  display: flex;\n  justify-content: center;\n  gap: 20px;\n  margin: 10px 0;\n  margin-bottom: 20px;\n}\n\n.trustStarContainer {\n  width: clamp(30px, 5vw, 40px);\n  height: clamp(30px, 5vw, 40px);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background-color: #219653;\n}\n\n.bottomText {\n  font-size: clamp(12px, 2vw, 14px);\n  color: #555454;\n}\n\n.bottomText span {\n  font-weight: bold;\n  text-decoration: underline;\n  color: #18181b;\n}\n\n@media (max-width: 768px) {\n  .pricingContainer {\n    padding-top: 80px;\n  }\n\n  .trustContainer {\n    flex-direction: column;\n  }\n  .googleCard {\n    max-width: 100%;\n  }\n}\n\n@media (max-width: 480px) {\n  .pricingContainer {\n    padding-top: 60px;\n  }\n\n\n  .cardContainer {\n    gap: 1.5rem;\n  }\n}\n\n.parent {\n  display: grid;\n  grid-auto-flow: dense;\n  grid-template-columns: repeat(9, auto);\n  grid-template-rows: auto;\n  gap: 10px;\n  width: auto;\n  margin-top: 40px;\n  row-gap: 20px;\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: center;\n}\n@media (width<=600px) {\n  .pricingCardContainer {\n    width: 80%;\n  }\n}\n/* .div1 {\n  grid-area: 1 / 1 / 2 / 3;\n}\n.div2 {\n  grid-area: 1 / 3 / 2 / 5;\n}\n.div3 {\n  grid-area: 1 / 6 / 2 / 8;\n}\n.div4 {\n  grid-area: 1 / 8 / 2 / 10;\n}\n.div5 {\n  grid-area: 2 / 1 / 3 / 3;\n  margin-left: -40px;\n  margin-right: 40px;\n}\n.div6 {\n  grid-area: 2 / 3 / 3 / 5;\n  margin-left: -27px;\n}\n.div7 {\n  grid-area: 2 / 6 / 3 / 8;\n  margin-left: 27px;\n  margin-right: -40px;\n}\n.div8 {\n  grid-area: 2 / 8 / 3 / 10;\n  margin-left: 40px;\n  margin-right: -40px;\n}\n.div9 {\n  grid-area: 3 / 2 / 4 / 4;\n}\n.div10 {\n  grid-area: 3 / 4 / 4 / 7;\n}\n.div11 {\n  grid-area: 3 / 7 / 4 / 9;\n}\n\n@media (max-width: 935px) {\n  .parent {\n    grid-template-columns: repeat(2, 1fr);\n  }\n  .div1,\n  .div2,\n  .div3,\n  .div4,\n  .div5,\n  .div6,\n  .div7,\n  .div8,\n  .div9,\n  .div10,\n  .div11 {\n    margin: 0;\n  }\n  .div1 {\n    grid-area: 1 / 1 / 2 / 2;\n  }\n  .div2 {\n    grid-area: 1 / 2 / 2 / 3;\n  }\n  .div3 {\n    grid-area: 2 / 1 / 3 / 2;\n  }\n  .div4 {\n    grid-area: 2 / 2 / 3 / 3;\n  }\n  .div5 {\n    grid-area: 3 / 1 / 4 / 2;\n  }\n  .div6 {\n    grid-area: 3 / 2 / 4 / 3;\n  }\n  .div7 {\n    grid-area: 4 / 1 / 5 / 2;\n  }\n  .div8 {\n    grid-area: 4 / 2 / 5 / 3;\n  }\n  .div9 {\n    grid-area: 5 / 1 / 6 / 2;\n  }\n  .div10 {\n    grid-area: 5 / 2 / 6 / 3;\n  }\n  .div11 {\n    grid-area: 6 / 1 / 7 / 2;\n  }\n}\n\n@media (max-width: 480px) {\n  .parent {\n    grid-template-columns: 1fr;\n  }\n  .div1 {\n    grid-area: 1 / 1 / 2 / 2;\n  }\n  .div2 {\n    grid-area: 2 / 1 / 3 / 2;\n  }\n  .div3 {\n    grid-area: 3 / 1 / 4 / 2;\n  }\n  .div4 {\n    grid-area: 4 / 1 / 5 / 2;\n  }\n  .div5 {\n    grid-area: 5 / 1 / 6 / 2;\n  }\n  .div6 {\n    grid-area: 6 / 1 / 7 / 2;\n  }\n  .div7 {\n    grid-area: 7 / 1 / 8 / 2;\n  }\n  .div8 {\n    grid-area: 8 / 1 / 9 / 2;\n  }\n  .div9 {\n    grid-area: 9 / 1 / 10 / 2;\n  }\n  .div10 {\n    grid-area: 10 / 1 / 11 / 2;\n  }\n  .div11 {\n    grid-area: 11 / 1 / 12 / 2;\n  }\n} */\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"pricingContainer": `pricingContainer_dCXgD`,
	"plansHeader": `plansHeader_cQZoX`,
	"containerP": `containerP_zLpTy`,
	"plansTitle": `plansTitle_iVwp0`,
	"cardsPlansContainer": `cardsPlansContainer_XIJHq`,
	"cardsContainer": `cardsContainer_xG9wR`,
	"card": `card_QRIIK`,
	"customButton": `customButton_yT9va`,
	"featuresContainer": `featuresContainer_SSWG5`,
	"slider": `slider_arTeq`,
	"lightText": `lightText_MCY6X`,
	"cardContainer": `cardContainer_m1QgT`,
	"row2": `row2_H4Kzs`,
	"reviewsTitle": `reviewsTitle_BAv_U`,
	"reviewsDescriptionLast": `reviewsDescriptionLast_Ad8Ya`,
	"startButton": `startButton_nBMFK`,
	"tableBenefitsContainer": `tableBenefitsContainer_mxM0w`,
	"benefitsTable": `benefitsTable_SjtT0`,
	"trustContainer": `trustContainer_C7pGr`,
	"googleCard": `googleCard_wJgi_`,
	"starsContainer": `starsContainer_OIS8Q`,
	"topTrustpilotStar": `topTrustpilotStar_NGfIj`,
	"googleLogo": `googleLogo_uf_yf`,
	"trustpilotCard": `trustpilotCard_cXJye`,
	"topContainer": `topContainer_F0E36`,
	"bottomContainer": `bottomContainer_l1dN2`,
	"trustpilotBottomStars": `trustpilotBottomStars_pBS4b`,
	"trustStarContainer": `trustStarContainer_v6HvN`,
	"bottomText": `bottomText_WoH3Z`,
	"parent": `parent_tCf9z`,
	"pricingCardContainer": `pricingCardContainer_URDsz`
};
export default ___CSS_LOADER_EXPORT___;
